// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i_Vj","option":"styles_option__2GEpp","active":"styles_active__14jvV"};